import BaseClass from "../BaseClass.js";

export default class PriceSelect extends BaseClass {

    constructor(element) {
        super(element);

        this.currency = null;
        this.currencyshorthands = null;
        this.currentPrice = null;
        this.disableCheaperOptions = false;
        this.allowDisablingDefault = false;
        this.userSelectedIndex = 0;
        this.mapping = [];

        this.$selectElement = null;
        this.$options = null;
        this.$childElement = null;
        this.$secondCurrencyContainer = null;

        this.priceChangeListener = null;
        this.priceUpdateListener = null;

        this.initialSelectedIndex = null;

        this.init();
    }

    init() {
        const mySelf = this;

        this.currency = this.$element.attr('data-currency');
        this.$selectElement = this.$element.find('select');

        this.$options = this.$selectElement.find('option');

        let $selectedOption = this.getSelected();
        if ($selectedOption.length == 1) {
            this.currentPrice = $selectedOption.val();
            let selectedIndex = this.$options.index($selectedOption);
            this.userSelectedIndex = selectedIndex;
            this.initialSelectedIndex = selectedIndex;
        }

        let mapping = this.$element.attr('data-mapping');
        if (mapping != undefined) {
            this.mapping = JSON.parse(mapping);
        }

        let currencyshorthands = this.$element.attr('data-currency-shorthands');
        if (currencyshorthands != undefined) {
            this.currencyshorthands = JSON.parse(currencyshorthands);
        }

        let childSelectId = this.$element.attr('data-child-select-id');

        if (childSelectId != undefined) {
            this.$childElement = $('#' + childSelectId);
        }

        let secondCurrencyContainer = this.$element.find('[data-type="second_currency_container"]');
        if (secondCurrencyContainer.length == 1) {
            this.$secondCurrencyContainer = secondCurrencyContainer;
        }

        let disableCheaperOptions = this.$element.attr('data-disable-cheaper-options');
        if (disableCheaperOptions != undefined) {
            this.disableCheaperOptions = Boolean(disableCheaperOptions);
        }

        let allowDisablingDefault = this.$element.attr('data-allow-disabling-default');
        if (allowDisablingDefault != undefined && allowDisablingDefault == true) {
            this.allowDisablingDefault = true;
        }

        this.priceChangeListener = function () {
            // Wird durch die Änderung im Selektor selbst getriggert
            mySelf.onPriceChange();
        };

        this.priceUpdateListener = function (event, data) {
            // Wird von einem Elternelement getriggert
            mySelf.setNewPriceSelection(data);
        };

        this.$selectElement.on('change', this.priceChangeListener);
        this.$selectElement.on('price:update', this.priceUpdateListener);

        setTimeout(function () {
            mySelf.onPriceChange();
        }, 100);

    }


    getSelected() {
        if (this.$selectElement != null) {
            return this.$selectElement.find('option:selected');
        }
        return null;
    }

    onPriceChange() {
        let $selectedOption = this.getSelected();

        if ($selectedOption.length == 1) {
            this.currentPrice = $selectedOption.val();
            let selectedIndex = this.$options.index($selectedOption);
            this.userSelectedIndex = selectedIndex;
            $selectedOption.trigger('price-select:changed');
            this.setSecondCurrencyPrice($selectedOption);
            this.displayPriceChangeHint(selectedIndex);

            this.updateChild(selectedIndex);
        }
    }

    updateChild(selectedIndex) {
        if (this.$childElement != null) {
            this.$childElement.trigger("price:update", {
                selectedIndex: selectedIndex
            });
        }
    }


    setNewPriceSelection(eventData) {
        // Wird nur im ChildElement durch das ParentElement getriggert

        if (this.$options == null) {
            return;
        }

        let selectedIndex = eventData.selectedIndex;

        let map = this.mapping[this.currency][this.currency];

        if (selectedIndex > 0) {
            if (selectedIndex < (map.length - 2)) {
                // Wir überspringen zwei Preisstufen, wegen der x.95 Preise, aber nur wenn der Preis größer als 0 ist
                selectedIndex = selectedIndex + 2;
            } else if (selectedIndex < (map.length - 1)) {
                // Ansonsten nur eine
                selectedIndex = selectedIndex + 1;
            }
        }

        let newIndex = map[selectedIndex];

        if (newIndex != undefined) {
            // this.updateSelection(newIndex);

            if (this.disableCheaperOptions) {
                this.disableOptionsUpTo(newIndex);
            }

            let $defaultOption = $(this.$options.get(0));

            if ($defaultOption.prop("selected") && !this.allowDisablingDefault) {
                // Defaultwert wurde ausgewählt und soll auch nicht deaktiviert oder abgewählt werden
                this.currentPrice = $defaultOption.val();
                this.updateChild(newIndex);
                return;
            }

            if (this.userSelectedIndex > newIndex) {
                newIndex = this.userSelectedIndex;
                // Durch die User ausgewählter Index darf nur nach oben korrigiert werden // Vorerst deaktiviert
            }

            this.$options.prop("selected", false);

            const $targetOption = $(this.$options.get(newIndex));

            if ($targetOption.length == 1) {
                $targetOption.prop("selected", true);
                this.currentPrice = $targetOption.val();
                this.setSecondCurrencyPrice($targetOption);
                this.$element.attr('selectedIndex', newIndex);
                this.displayPriceChangeHint(newIndex, true);

            }
        }
    }

    displayPriceChangeHint(newIndex, child = false) {

        let $priceHintContainer = this.$element.parents().find('[data-type="pricehint-container"]');

        if ($priceHintContainer.length != 0) {
            if (this.initialSelectedIndex != newIndex) {
                $priceHintContainer.removeClass('hidden');
                if (!child) {
                    $priceHintContainer.attr('data-change-available', 1);
                }
            } else {
                if (child) {
                    if ($priceHintContainer.attr('data-change-available') != 1) {
                        $priceHintContainer.addClass('hidden');
                    }
                } else {
                    $priceHintContainer.addClass('hidden');
                    $priceHintContainer.attr('data-change-available', 0);
                }

            }
        }
    }


    disableOptionsUpTo(maxIndex) {
        if (this.$options == null) {
            return;
        }

        const mySelf = this;

        this.$options.each(function (index, option) {
            const $option = $(option);
            if ($option.attr('data-hard-disabled') != 'disabled') {
                $option.prop('disabled', false);
            }
        });

        if (maxIndex > 0) {
            this.$options.each(function (index, option) {
                if (index >= maxIndex) {
                    return false;
                }
                const $option = $(option);
                const isDefaultOption = $option.hasClass('default-value');
                if (isDefaultOption && !mySelf.allowDisablingDefault) {
                    return;
                }
                $option.prop('disabled', true);
            });
        }
    }

    setSecondCurrencyPrice($targetOption) {
        let mySelf = this;

        if (this.$secondCurrencyContainer != null) {
            this.$secondCurrencyContainer.removeClass("hidden");
            this.$secondCurrencyContainer.children('[data-type="price"]').html("");

            let otherPrice = null;

            this.currencyshorthands.forEach(function (currencyshorthand, index) {
                if (currencyshorthand != mySelf.currency) {
                    let dataAttrName = 'data-' + currencyshorthand.toLowerCase() + '-price';
                    if (otherPrice == null) {
                        otherPrice = $targetOption.attr(dataAttrName);
                    } else {
                        // Wenn es mehrere Währungen gibt, müssen diese hintereinander aufgereiht werden.
                        otherPrice = otherPrice + ',' + $targetOption.attr(dataAttrName);
                    }
                }
            });
            if (otherPrice != null) {
                mySelf.$secondCurrencyContainer.children('[data-type="price"]').html(otherPrice);
            } else {
                this.$secondCurrencyContainer.addClass("hidden");
            }
        }

    }
}
